import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { CUSTOMER_TYPES } from "../../Constants/config";
import { setApplicationType } from "../../Redux/store/accountTypeSlice";
import { debounce } from "lodash";
import { useToast } from "../../Utils/toastContext";
import { clearCardCurrencyName } from "../../Redux/store/userSlice";
import useAutoLogout from "../custom-logout/custom-logout";
import SessionWarningModal from "../custom-logout/session-timeout-popup";
import { clearFileIdsRedux } from "../../Redux/store/userSlice";
import {
  clearStepStatus,
  clearStepStatusShareholder,
} from "../../Redux/store/onboardingFormSlice";
import AgreementCard from "../../Components/onboarding/agreement-card";
import DocumentPreview from "../../Pages/Create-Investment/documentpreview";
import {
  clearApplicationTypeShareHolder,
  clearApplicationType,
} from "../../Redux/store/accountTypeSlice";
const OnboardingHeader = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const logoutDropdown = useRef(null);
  const customerTypeDropdown = useRef(null);
  const { showToast } = useToast();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenCustomer, setIsDropdownOpenCustomer] = useState(false);
  const username = useSelector((state) => state.user.username);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredItemCustomer, setHoveredItemCustomer] = useState(null);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(0);
  const [selectedItemCustomer, setSelectedItemCustomer] = useState(1);
  const [selectedItemCustomerLabel, setSelectedItemCustomerLabel] =
    useState("Individual");
  const [currentType, setCurrentType] = useState(null);
  const [loading, setLoading] = useState(false);

  const [isConfirmAdvisor, setIsConfirmAdvisor] = useState(false);
  const [isConfirmChangeApplication, setIsConfirmChangeApplication] =
    useState(false);
  const [isAdvisorExist, setIsAdvisorExist] = useState(false);
  const [advisorName, setAdvisorName] = useState("");
  const [advisorId, setAdvisorId] = useState(null);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const handleNotifications = () => setOpen(!open);
  const [readItems, setReadItems] = useState({});
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [filter, setFilter] = useState("");
  const [open, setOpen] = useState(false);
  const fileThirdPartyRef = useRef(null);
  const [agreements, setagreements] = useState([]);
  const [lockedAgreements, setLockedAgreements] = useState({});
  const [agreedMap, setAgreedMap] = useState([]);

  const [fileThirdParty, setFileThirdParty] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const historyData = [
    {
      added_by: {
        first_name: "Peter",
        last_name: "Yassa",
        role: "Customer",
        avatar: "/avatar.svg",
      },
      action_text: "has saved the Personal Details Section.",
      unique_id: "1",
      actions: ["Decline", "Confirm"],
      uploaded_at: "2025-11-06T08:26:00",
      notes:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      added_by: {
        first_name: "John",
        last_name: "Anderson",
        role: "Onboarding Staff",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Email Personal Details Section.",
      unique_id: "2",
      uploaded_at: "2025-11-05T19:34:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
    {
      added_by: {
        first_name: "Jason",
        last_name: "Quinn",
        role: "Advisor",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Date of Birth Personal Details Section.",
      unique_id: "",
      uploaded_at: "2025-09-18T20:00:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
    {
      added_by: {
        first_name: "Brian",
        last_name: "Vaughan",
        role: "Admin",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Address Personal Details Section.",
      unique_id: "",
      uploaded_at: "2025-09-17T19:34:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
    {
      added_by: {
        first_name: "John",
        last_name: "Anderson",
        role: "Onboarding Staff",
        avatar: "/avatar.svg",
      },
      action_text: "has edited the Email Personal Details Section.",
      unique_id: "",
      uploaded_at: "2025-09-17T20:00:00",
      notes: "",
      actions: ["Decline", "Confirm"],
    },
  ];
  const submitAgreementAPI = async (agreementType) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/agreements/${agreementType}/agree`;
    let bodyData = {
      agreed: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const THIRD_PARTY_ENUM = "THIRD_PARTY_AUTHORITY";
  const isAgreementAccepted = (agreement) => {
    return agreement.status === "AGREED" || agreedMap[agreement.enum] === true;
  };
  const validateAgreementsBeforeNext = () => {
    const thirdPartyAgreement = agreements
      .map(mapAgreementUI)
      .find((a) => a.enum === THIRD_PARTY_ENUM && shouldShowAgreement(a.enum));

    // If not applicable / not shown → valid
    if (!thirdPartyAgreement) {
      return { isValid: true, missing: [] };
    }

    const accepted = isAgreementAccepted(thirdPartyAgreement);

    return {
      isValid: accepted,
      missing: accepted ? [] : [thirdPartyAgreement],
    };
  };

  const handleAcceptAgreement = async (checked, agreement) => {
    let toastMessage = null;
    const enumKey = agreement.enum;

    if (lockedAgreements[enumKey]) return; // 🚫 already accepted
    try {
      setLoading(true);
      if (checked) {
        const response = await submitAgreementAPI(agreement.id);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: "success",
          };
          getAgreements();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const shouldShowAgreement = (agreementEnum) => {
    if (agreementEnum === "THIRD_PARTY_AUTHORITY") return true;

    return false; // show all others in all cases
  };
  const notificationsDropdownRef = useRef(null);
  // Format date groups
  const groupByDate = (data) => {
    const groups = {};
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    data.forEach((item) => {
      const itemDate = new Date(item.uploaded_at);
      const itemDateString = itemDate.toDateString();

      let groupKey = itemDateString;

      // Compare with today and yesterday (only date, not time)
      if (itemDate.toDateString() === today.toDateString()) {
        groupKey = "today";
      } else if (itemDate.toDateString() === yesterday.toDateString()) {
        groupKey = "yesterday";
      }

      if (!groups[groupKey]) groups[groupKey] = [];
      groups[groupKey].push(item);
    });

    return groups;
  };

  const groupedData = groupByDate(historyData);
  const handleMarkAsRead = (itemId) => {
    setReadItems((prev) => ({
      ...prev,
      [itemId]: true, // mark specific item as read
    }));
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const mapAgreementUI = (agreement) => {
    return {
      id: agreement.agreement_type.id,
      enum: agreement.agreement_type.enum,
      name: agreement.agreement_type.name,
      description: agreement.agreement_type.description,
      required: agreement.is_required,
      mode: agreement.mode.enum, // UPLOAD_SIGNED | PREVIEW_TICK
      document: agreement.document,
      preview: agreement.preview_document,
      status: agreement.status.enum,
    };
  };
  const getAgreements = async () => {
    try {
      const response = await GetAPIcalls(`/v1/onboarding/agreements`);

      if (response.status == 200) {
        setagreements(response.data.agreements);
        const agreedMapFromApi = {};
        const lockedMapFromApi = {};

        response.data.agreements.forEach((item) => {
          const enumKey = item.agreement_type.enum;
          const isAccepted = item.status?.enum === "AGREED" || !!item.agreed_at;

          agreedMapFromApi[enumKey] = isAccepted;
          lockedMapFromApi[enumKey] = isAccepted;
        });

        setAgreedMap(agreedMapFromApi);
        setLockedAgreements(lockedMapFromApi);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const handleFileChangeThirdParty = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileThirdParty({
              ...fileThirdParty,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileThirdParty({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleLogout = () => {
    localStorage.removeItem("lastActivity");
    localStorage.removeItem("jwtToken");
    dispatch(clearApplicationType());
    dispatch(clearApplicationTypeShareHolder());
    dispatch(clearCardCurrencyName());
    window.location.href = "/login";
  };
  const { timeLeft, isWarning, stayConnected } = useAutoLogout(handleLogout, {
    inactivityLimit: 10 * 60 * 1000, // 10 minutes
    warningThreshold: 60 * 1000, // 60 seconds show warning
  });
  const menuItemspopUp = [
    {
      id: 1,
      label: "Delete Account",
      defaultIcon: "/trash.svg", // Replace with your default icon URL
      selectedIcon: "/trash-white.svg", // Replace with your selected icon URL
    },
    {
      id: 2,
      label: "Logout",
      defaultIcon: "/logout.svg",
      selectedIcon: "/logout-white.svg",
    },
  ];
  const handleChangeMenu = (id) => {
    setSelectedItem(id);
    // toggleMenu();
    if (id == 2) {
      localStorage.removeItem("jwtToken");
      dispatch(clearApplicationType());
      dispatch(clearApplicationTypeShareHolder());
      navigate("/login");
    }
    setIsDropdownOpen(false);
  };
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setRefNumber(pasteData.split(""));
    }
    event.preventDefault();
  };
  const createRefNumber = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/personal-information/verify-advisor`;
    const bodyData = {
      advisor_number: refNumber.join(""),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleDeleteFileThirdParty = () => {
    setFileThirdParty({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    if (fileThirdPartyRef.current) {
      fileThirdPartyRef.current.value = null;
    }
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const addAdvisor = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/personal-information/request-advisor`;
    const bodyData = {
      advisor_id: advisorId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleChange = (value, index) => {
    setIsAdvisorExist(false);
    setAdvisorName("");
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...refNumber];
      newOtp[index] = value;
      setRefNumber(newOtp);
      if (value && index < 6) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !refNumber[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  const handleAddRefNumber = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await createRefNumber();
        if (response.status == 200) {
          setIsAdvisorExist(true);
          setAdvisorName(response.data.advisor.name);
          setAdvisorId(response.data.advisor.id);
        } else {
          setIsAdvisorExist(false);
          setAdvisorName("Advisor not found");
          setAdvisorId(null);
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        setIsAdvisorExist(false);
        setAdvisorId(null);
        setAdvisorName("Advisor not found");
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [refNumber], // Dependencies
  );
  const handleSendAdvisorRequest = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addAdvisor();
        if (response.status == 200) {
          setIsConfirmAdvisor(false);
          toastMessage = { message: response.message, type: "success" };
        } else {
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [advisorId], // Dependencies
  );
  const handleChangeMenuCustomer = (item) => {
    setIsConfirmChangeApplication(true);
    setCurrentType(item);
    setIsDropdownOpenCustomer(false);
  };
  const toggleDropdownCustomer = (event) => {
    event.stopPropagation(); // Prevent click from propagating to the document listener
    setIsDropdownOpenCustomer((prev) => !prev);
  };
  const toggleDropdown = (event) => {
    event.stopPropagation(); // Prevent click from propagating to the document listener
    setIsDropdownOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        logoutDropdown.current &&
        !logoutDropdown.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        customerTypeDropdown.current &&
        !customerTypeDropdown.current.contains(event.target)
      ) {
        setIsDropdownOpenCustomer(false);
      }
      if (
        notificationsDropdownRef.current &&
        !notificationsDropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (isConfirmAdvisor) {
      getAgreements();
    }
  }, [isConfirmAdvisor]);
  return (
    <header className="pt-4 px-4 flex flex-wrap items-center justify-between py-0">
      {/* Left: Logo */}
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      <div className="w-full md:w-auto flex-col md:flex-row flex justify-between items-center">
        <div className="flex items-center mr-10">
          <img
            src="/Ratified-new.svg"
            alt="Caprock Logo"
            className="h-8 sm:h-9 md:h-10"
          />
          <span className="-ml-0.5 font-bold text-sm sm:text-base">
            Ratified
          </span>
        </div>
        {/* Back Button */}

        {/* Mobile Center Message Toggle (optional hamburger or info icon) */}
        <div className="flex flex-wrap items-center justify-between w-full gap-3 ml-36 mt-2">
          {/* Back Button */}
          {location.pathname.startsWith("/onboarding-shareholder") && (
            <button
              className="flex items-center space-x-2 bg-white px-3 py-3 rounded-xl shadow-md"
              onClick={() => {
                dispatch(clearStepStatus());
                dispatch(clearStepStatusShareholder());
                navigate(location.state?.from || "/onboarding");
              }}
            >
              <img src="/arrow-left.svg" alt="Back" className="w-4 h-4" />
              <span className="text-sm lg:inline hidden font-medium">Back</span>
            </button>
          )}

          {/* Advisor Box */}
          <div className="flex items-center space-x-2 border rounded-xl px-3 py-1.5 bg-yellow-50 border-yellow-300 max-w-sm">
            <p className="text-xs text-black">
              Click here if you would like your advisor to complete this form on
              your behalf!
            </p>
            <button
              onClick={() => setIsConfirmAdvisor(true)}
              className="bg-black text-white text-xs rounded-full px-3 py-1 font-medium"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>

      {/* Right: Dropdowns (stacked on small screens, horizontal on md+) */}
      <div className="w-full md:w-auto flex flex-col md:flex-row items-start md:items-center space-y-2 md:space-y-0 md:space-x-4 mt-2 md:mt-0">
        {/* Application Type Dropdown */}
        {/* <div ref={customerTypeDropdown} className="relative w-full md:w-auto">
          <div
            onClick={toggleDropdownCustomer}
            className={`flex items-center justify-between md:w-64 w-full rounded-xl p-2 cursor-pointer transition-colors duration-300 ${
              isDropdownOpenCustomer
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            <img
              src={
                !isDropdownOpenCustomer
                  ? "/document-text-black.svg"
                  : "/document-text.svg"
              }
              alt="Doc"
              className="w-6 h-6"
            />
            <div className="ml-2 flex-1">
              <p className="text-xs font-medium text-[#005A9C]">
                Change Application Type
              </p>
              <p
                className={`${
                  isDropdownOpenCustomer ? "text-white" : "text-black"
                } text-sm`}
              >
                {selectedItemCustomerLabel}
              </p>
            </div>
            <img
              src={
                !isDropdownOpenCustomer
                  ? "/chevron-down-black.svg"
                  : "/chevron-down.svg"
              }
              alt="Dropdown Icon"
              className={`w-4 h-4 transform transition-transform ${
                isDropdownOpenCustomer ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
          {isDropdownOpenCustomer && (
            <div
              className="absolute mt-2 left-0 w-full md:w-64 bg-white rounded-lg shadow-lg z-[999]"
              onClick={(e) => e.stopPropagation()}
            >
              <ul className="py-2 px-2">
                {CUSTOMER_TYPES.map((item) => (
                  <li
                    key={item.value}
                    onMouseEnter={() => setHoveredItemCustomer(item.value)}
                    onMouseLeave={() => setHoveredItemCustomer(null)}
                    onClick={() => handleChangeMenuCustomer(item)}
                    className={`flex items-center px-4 py-2 rounded-md space-x-2 cursor-pointer transition-all duration-300 mb-1 ${
                      selectedItemCustomer === item.value
                        ? "bg-black text-white"
                        : ""
                    }
                    ${
                      hoveredItemCustomer === item.value
                        ? "bg-gray-400 text-white"
                        : ""
                    }
                    `}
                  >
                    <span className="text-sm">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div> */}

        {/* Profile & Notifications */}
        <div
          ref={logoutDropdown}
          className="relative flex items-center space-x-4 w-full md:w-auto"
        >
          <div
            onClick={toggleDropdown}
            className={`flex items-center space-x-2 rounded-xl p-2 w-full md:w-auto cursor-pointer transition-colors duration-300 ${
              isDropdownOpen ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            <img
              src="/login-image.svg"
              alt="User Avatar"
              className="w-8 h-8 sm:w-10 sm:h-10 rounded-full"
            />
            <div className="sm:block text-sm whitespace-nowrap">
              <p className="font-medium text-[#005A9C]">Onboarding</p>
              <p className={`${isDropdownOpen ? "text-white" : "text-black"}`}>
                {username}
              </p>
            </div>
            <img
              src={
                !isDropdownOpen
                  ? "/chevron-down-black.svg"
                  : "/chevron-down.svg"
              }
              alt="Dropdown Icon"
              className="w-4 h-4"
            />
          </div>

          {isDropdownOpen && (
            <div
              className="absolute top-full mt-2 md:left-0 right-1 w-20 w-full md:w-44 bg-white rounded-lg shadow-lg z-[999]"
              onClick={(e) => e.stopPropagation()}
            >
              <ul className="py-2 px-2">
                {menuItemspopUp.map((item) => (
                  <li
                    key={item.id}
                    onMouseEnter={() => setHoveredItem(item.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={() => handleChangeMenu(item.id)}
                    className={`flex items-center px-4 py-2 rounded-md space-x-2 cursor-pointer transition-all duration-300 ${
                      hoveredItem === item.id || selectedItem === item.id
                        ? "bg-black text-white"
                        : "text-black hover:bg-black hover:text-white"
                    }`}
                  >
                    <img
                      src={
                        hoveredItem === item.id || selectedItem === item.id
                          ? item.selectedIcon
                          : item.defaultIcon
                      }
                      alt={item.label}
                      className="w-5 h-5"
                    />
                    <span className="text-sm">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Notifications */}
          <div className="relative" ref={notificationsDropdownRef}>
            {/* Lamp / Notification Button */}
            <button
              onClick={handleNotifications}
              aria-label="Notifications"
              className="relative bg-white h-12 p-2 rounded-xl focus:outline-none"
            >
              <img
                src="/lamp.svg"
                alt="Notifications"
                className="w-6 h-6 sm:w-8"
              />
              <span className="absolute -top-1 -right-1 bg-[#FF5050] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                {historyData.length}
              </span>
            </button>

            {/* Notification Dropdown */}
            {open && (
              <div className="absolute right-0 mt-3 w-[350px] sm:w-[420px] bg-white border border-gray-200 rounded-2xl shadow-lg z-50">
                {/* Header */}
                <div className="flex justify-between items-center px-4 py-3 border-b border-gray-100">
                  <div className="flex items-center gap-2">
                    <img
                      src="/lamp.svg"
                      alt="Notifications"
                      className="w-5 h-5 sm:w-6 sm:h-6"
                    />
                    <h3 className="font-medium text-black text-sm sm:text-base">
                      Notifications
                    </h3>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="text-xs sm:text-sm text-black font-medium underline whitespace-nowrap">
                      Mark all as read
                    </button>
                    <img
                      onClick={() => {
                        setOpen(false);
                      }}
                      src="/add.svg"
                      alt="Add"
                      className="w-10 h-10 cursor-pointer"
                    />
                  </div>
                </div>
                <div className=" text-xs font-medium pt-6 pr-4 flex-wrap items-center">
                  <div className="flex mb-2 ml-2">
                    <button
                      onClick={() => {
                        setFilter("");
                      }}
                      className={`shadow-md flex items-center justify-center gap-1 px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                        filter === ""
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <span>All</span>
                      <span className="bg-[#FF5050] text-white text-[10px] rounded-full px-1.5 py-[1px]">
                        12
                      </span>
                    </button>
                    <button
                      onClick={() => {
                        setFilter("inbox");
                      }}
                      className={`shadow-md flex items-center justify-center gap-1  lg:px-4 px-2 py-2 border-r border-gray-100 ${
                        filter === "inbox"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <span>Inbox</span>
                      <span className="bg-[#FF5050] text-white text-[10px] rounded-full px-1.5 py-[1px]">
                        10
                      </span>
                    </button>
                    <button
                      onClick={() => {
                        setFilter("general");
                      }}
                      className={`shadow-md flex items-center justify-center gap-1 relative px-4 py-2 rounded-r-xl ${
                        filter === "general"
                          ? "bg-black text-white"
                          : "bg-white text-black"
                      }`}
                    >
                      <span>General</span>
                      <span className="bg-[#FF5050] text-white text-[10px] rounded-full px-1.5 py-[1px]">
                        10
                      </span>
                    </button>
                  </div>
                </div>

                {/* Notifications List */}
                {/* <div className="max-h-[400px] overflow-y-auto p-3 space-y-3">
                  <p className="text-gray-400 text-xs font-medium px-2">
                    Today
                  </p>
                  {notifications.map((n) => (
                    <div
                      key={n.id}
                      className="bg-[#F8FAFF] border border-gray-100 rounded-xl p-3 shadow-sm hover:shadow-md transition"
                    >
                      <div className="flex items-start gap-3">
                        <img
                          src="/avatar.svg"
                          alt={n.name}
                          className="w-8 h-8 rounded-full object-cover border border-gray-200"
                        />
                        <div className="flex-1 text-sm text-gray-700">
                          <p>
                            <span className="font-semibold">{n.name}</span>{" "}
                            <span className="text-[#3047EC] font-semibold">
                              {n.role}
                            </span>{" "}
                            {n.message}
                          </p>

                          {n.actions.length > 0 && (
                            <div className="flex gap-2 mt-2">
                              {n.actions.map((action, i) => (
                                <button
                                  key={i}
                                  className={`px-3 py-1 rounded-lg text-xs font-medium ${
                                    action === "Confirm" || action === "Approve"
                                      ? "bg-[#E7EDFF] text-[#1A4CB4]"
                                      : "bg-white border text-gray-600"
                                  }`}
                                >
                                  {action}
                                </button>
                              ))}
                            </div>
                          )}

                          <div className="text-gray-400 text-xs mt-1">
                            {n.time}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}
                <div className="text-xs space-y-6 h-[60vh] overflow-y-auto px-2 mb-4">
                  {Object.entries(groupedData).map(
                    ([date, items], groupIndex) => (
                      <div key={groupIndex} className="space-y-3">
                        {/* Date Divider */}
                        <div className="relative flex items-center justify-center">
                          <div className="absolute w-full border-t border-gray-300"></div>
                          <span className="relative bg-white rounded-full font-semibold px-4 text-black border text-xs font-medium">
                            {date === "today"
                              ? "Today"
                              : date === "yesterday"
                                ? "Yesterday"
                                : date}
                          </span>
                        </div>

                        {/* Items */}
                        {items.map((item, index) => {
                          const isRead = readItems[item.unique_id];
                          return (
                            <div
                              key={index}
                              onClick={() => handleMarkAsRead(item.unique_id)}
                              className={`p-4 rounded-md cursor-pointer transition-all duration-200 ${
                                !isRead ? "bg-blue-50" : "bg-gray-50"
                              }`}
                            >
                              <div className="flex items-start justify-between">
                                {/* Left: Blue line + Avatar + Content */}
                                <div className="flex items-start space-x-3">
                                  {/* Blue line indicator for unread */}
                                  {!isRead && (
                                    <img
                                      src="/unread-notification.svg"
                                      alt="User Avatar"
                                      className="mt-4"
                                    />
                                  )}

                                  {/* Avatar */}
                                  <img
                                    src={item.added_by.avatar || "/avatar.svg"}
                                    alt="User Avatar"
                                    className="h-10 w-10 rounded-full border"
                                  />

                                  {/* Text */}
                                  <div>
                                    <p className="text-xs">
                                      <span className="font-medium">
                                        {item.added_by.first_name}{" "}
                                        {item.added_by.last_name}
                                      </span>{" "}
                                      <span className="text-[#3047EC] font-medium">
                                        {item.added_by.role}
                                      </span>{" "}
                                      <span className="text-gray-600">
                                        {item.action_text}{" "}
                                      </span>
                                      <span className="font-medium">
                                        {item.unique_id}
                                      </span>
                                    </p>

                                    {item.actions?.length > 0 && (
                                      <div className="flex gap-2 mt-2">
                                        {item.actions.map((action, i) => (
                                          <button
                                            key={i}
                                            className={`px-3 py-1 rounded-lg text-xs font-medium ${
                                              action === "Confirm" ||
                                              action === "Approve"
                                                ? "bg-[#3047EC] text-white"
                                                : "bg-white border border-black text-black"
                                            }`}
                                          >
                                            {action}
                                          </button>
                                        ))}
                                      </div>
                                    )}

                                    {/* Time */}
                                    <p className="text-xs mt-2 text-gray-500 flex items-center space-x-2">
                                      <img
                                        src="/clock-black.svg"
                                        alt="Time Icon"
                                        className="h-4 w-4"
                                      />
                                      <span>
                                        {new Date(
                                          item.uploaded_at,
                                        ).toLocaleTimeString([], {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ),
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isConfirmAdvisor && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
            <p class="text-sm text-black mb-4">
              Do you want your advisor <br />
              to fill out the application on your behalf?
            </p>
            <div className="mb-2 w-full">
              <p className="text-[#868686]  text-xs mt-1 w-full break-words leading-snug">
                Please enter the advisor reference number if you have been
                provided with one.
              </p>
              <label
                htmlFor="custodianFee"
                className="text-left text-sm text-labelColour block w-full"
              >
                Advisor Ref No
              </label>
            </div>

            <div className="flex w-full flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
              {/* Input Fields */}
              <div
                onPaste={handlePaste}
                className="flex mb-2 justify-center flex-wrap gap-2"
              >
                {refNumber.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className={`w-8 h-8
            dark:bg-[#101010] ${digit ? "border-[#003478]" : "grey"}
            dark:border-[#4F4F4F] appearance-none border-2 rounded px-2 py-0.5
            dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black 
            text-base font-medium leading-tight focus:outline-none focus:shadow-outline input-main`}
                  />
                ))}
              </div>

              {/* Save Button */}
              <button
                disabled={!refNumber.every((digit) => digit !== "")}
                onClick={(e) => {
                  e.preventDefault();
                  if (refNumber.length < 7) {
                    showToast("Please Enter Valid number", "error"); // Success toast
                    return;
                  }
                  setLoading(true);
                  handleAddRefNumber(e);
                }}
                className={`text-white text-sm rounded-full px-6 py-2 w-full md:w-auto ${
                  refNumber.every((digit) => digit !== "")
                    ? "bg-black"
                    : "bg-gray-300"
                }`}
              >
                Save
              </button>
            </div>

            <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
              <span className="text-sm text-labelColour font-medium">
                Advisor Name:
              </span>
              {isAdvisorExist && advisorName && (
                <img src="/valid.svg" alt="User Icon" className="w-4 h-4" />
              )}
              {!isAdvisorExist && advisorName && (
                <img src="/danger.svg" alt="User Icon" className="w-4 h-4" />
              )}
              <span
                className={`text-sm ml-2 font-medium ${
                  isAdvisorExist
                    ? "text-black text-sm"
                    : "text-[#FF5050] text-xs"
                }`}
              >
                {advisorName}
              </span>
            </div>
            <div className="flex items-center justify-between">
              {agreements
                .map(mapAgreementUI)
                .filter((a) => shouldShowAgreement(a.enum))
                .map((agreement) => (
                  <AgreementCard
                    key={agreement.enum}
                    agreement={agreement}
                    agreed={agreedMap[agreement.enum]}
                    isLocked={lockedAgreements[agreement.enum]}
                    onPreview={(e) => handleFileClick(e, agreement.preview)}
                    setAgreed={(checked) =>
                      handleAcceptAgreement(checked, agreement)
                    }
                  />
                ))}
            </div>
            <div class="flex justify-center space-x-4 mt-4">
              <button
                onClick={() => {
                  setIsConfirmAdvisor(false);
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={(e) => {
                  setLoading(true);
                  handleSendAdvisorRequest(e);
                }}
                disabled={
                  isAdvisorExist &&
                  advisorName &&
                  fileThirdParty.value &&
                  validateAgreementsBeforeNext().isValid
                    ? false
                    : true
                }
                class={`px-6 py-2 text-white text-xs  rounded-full font-medium hover:bg-gray-800"${
                  isAdvisorExist &&
                  advisorName &&
                  fileThirdParty.value &&
                  validateAgreementsBeforeNext().isValid
                    ? " bg-black"
                    : " bg-gray-600"
                }`}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmChangeApplication && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button class="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div class="flex justify-center items-center mb-4">
              <div class="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 class="text-lg font-medium mb-2">
              Are you sure you want to discard the current application?
            </h2>
            <p class="text-sm text-black mb-4">
              Changing your application type will result in discarding all the
              information currently filled, and you will be required to fill out
              the new application from the beginning.
            </p>

            <div class="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmChangeApplication(false);
                }}
                class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setSelectedItemCustomer(currentType.value);
                  setSelectedItemCustomerLabel(currentType.label);
                  setHoveredItemCustomer(null);
                  setIsConfirmChangeApplication(false);
                  dispatch(setApplicationType(currentType.value));
                  setCurrentStep(1);
                }}
                class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <SessionWarningModal
        isOpen={isWarning}
        timeLeft={timeLeft}
        onStayConnected={stayConnected}
        onLogout={handleLogout}
      />
    </header>
  );
};

export default OnboardingHeader;
